import { render, staticRenderFns } from "./eventActivityModel.vue?vue&type=template&id=68dd6091&scoped=true&lang=pug&"
import script from "./eventActivityModel.vue?vue&type=script&lang=js&"
export * from "./eventActivityModel.vue?vue&type=script&lang=js&"
import style0 from "./eventActivityModel.vue?vue&type=style&index=0&id=68dd6091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd6091",
  null
  
)

export default component.exports